import styled from "@emotion/styled";
import React from "react";
import { useSelector } from "react-redux";

import Footer from "../../components/Footer";
import luckyNumbersBackground from "../../assets/luckynumbersbackground.png";
import ToolHelper from "../../utils/ToolHelper";

const LuckyNumbersTab = (props) => {
const { rafflesLuckyNumbers } = useSelector((state) => state.raffles);

const renderVouchers = (data) => {
    return (
      <div className="vouchers-card" key={data?.Number__c}>
        <span className="vouchers-txt">{ToolHelper?.maskVoucher(data?.Number__c)}</span>
      </div>
    );
  };
  return (
    <Container background={luckyNumbersBackground}>
      <div className="Content">
        <div className="banner-container">
          <img
            src={luckyNumbersBackground}
            alt="background"
            className="backgroundImage"
          />

          <span className="banner-title-txt">Seus números da sorte</span>
          <span className="banner-numbers-txt">{rafflesLuckyNumbers?.length || 0}</span>
          <span className="banner-subtitle-txt">Números da sorte gerados</span>
        </div>
        {rafflesLuckyNumbers?.length > 0 && (
          <>
            <div className="disclaimer-container">
              <span className="disclaimer-txt">
                Estes são os Números da Sorte já gerados para você concorrer aos
                SuperPrêmios. Boa sorte!
              </span>
            </div>
            <div className="vouchers-container" >
              {rafflesLuckyNumbers?.length > 0 && rafflesLuckyNumbers.map(renderVouchers)}
            </div>
          </>
        )}
      </div>
      
      <Footer />
    </Container>
  );
};

export default LuckyNumbersTab;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100vw;

  .Content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    margin: 88px 0 45px 0;
    gap: 24px;
    padding: 0 32px;

    @media (max-width: 900px) {
      margin: 45px 0 45px 0;
      padding: 0 16px;
    }
  }

  .banner-container {
    display: flex;
    flex-direction: column;
    background: #006f3d;
    border: 1px solid #dae753;
    border-radius: 16px;
    padding: 53px 223px;
    position: relative;
    z-index: 1;
    gap: 16px;

    @media (max-width: 900px) {
      width: 100%;
      max-width: 1200px;
      padding: 53px 0px;
    }

    .backgroundImage {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.4;
      z-index: -1;
      border-radius: 16px;
    }

    .banner-title-txt {
      font-family: "Roboto Condensed";
      font-size: 32px;
      line-height: 37.5px;
      font-weight: 600;
      color: #ffffff;
      text-transform: uppercase;
      text-align: center;
      @media (max-width: 900px) {
        font-size: 32px;
        line-height: 37.5px;
      }
    }
    .banner-numbers-txt {
      font-family: "Roboto Condensed";
      font-size: 96px;
      line-height: 112.5px;
      font-weight: 900;
      color: #dae753;
      text-transform: uppercase;
      text-align: center;

      @media (max-width: 900px) {
        /* font-size: 32px;
        line-height: 37.5px; */
      }
    }
    .banner-subtitle-txt {
      font-family: "Roboto Condensed";
      font-size: 20px;
      line-height: 23.44px;
      font-weight: 600;
      color: #ffffff;
      text-transform: uppercase;
      text-align: center;

      @media (max-width: 900px) {
        /* font-size: 32px;
        line-height: 37.5px; */
      }
    }
  }

  .disclaimer-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 90px;

    @media (max-width: 900px) {
      margin-top: 30px;
    }

    .disclaimer-txt {
      font-family: "Roboto";
      font-size: 24px;
      line-height: 28px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;

      @media (max-width: 900px) {
        /* font-size: 24px;
        line-height: 28px; */
      }
    }
  }

  .vouchers-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 1200px;
    gap: 24px;
    margin-top: 65px;

    @media (max-width: 900px) {
      gap: 16px;
      margin-top: 30px;
    }

    .vouchers-card {
      background-color: #006f3d;
      border-radius: 16px;
      padding: 16px 24px;

      .vouchers-txt {
        font-family: "Roboto";
        font-size: 32px;
        line-height: 37.5px;
        font-weight: 600;
        color: #ffffff;
        text-transform: uppercase;
        text-align: center;

        @media (max-width: 900px) {
          /* font-size: 32px;
          line-height: 37.5px; */
        }
      }
    }
  }
`;
